import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../context/Authcontext'
import './userLogo.css'
import { Link } from 'react-router-dom'
import { useToggle } from '../../../context/toggle/toggleBtn'

export const UserLogo = () => {

    const { userInfo } = useContext(AuthContext)
    const [initialLetter, setInitialLetter] = useState()

    const {isActive , toggleBTN} = useToggle()

    useEffect(() => {
        if (userInfo) {
            const initial = userInfo.name.charAt(0).toUpperCase()
            setInitialLetter(initial)
        }
    }, [userInfo])

    return (

        <Link to="/Profile" className='a-profession' onClick={() => toggleBTN()}>
        <div className='user-profile'>
            <div className="initials-container-responsive">
                <span className="initials">{initialLetter}</span>
            </div>
            {userInfo && <p className="FirstName name-size">{userInfo.name}</p>}
        </div>
        </Link>

    )
}
